import React from "react";
import '../index.css'

function Services() {
    const services = [
        { title: "Inspektion & Wartung", icon: "🔧" },
        { title: "Reifenwechsel & -service", icon: "🛞" },
        { title: "Karosserie & Lack", icon: "🎨" },
        { title: "Elektronik & Diagnose", icon: "💻" },
    ];

    return (
        <section id="services" className="py-20 px-4 bg-gray-50/70 text-center">
            <h3 className="text-3xl font-bold mb-12">Unsere Leistungen</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
                {services.map((s, idx) => (
                    <div key={idx} className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
                        <div className="text-4xl mb-4">{s.icon}</div>
                        <h4 className="text-xl font-semibold">{s.title}</h4>
                    </div>
                ))}
            </div>
        </section>
    );
}


export default Services;
